// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"xN","backgroundimage":"yN","header":"zN","headerwrap":"AN","title":"BN","promomessage":"CN","upsellItem":"EN","upsellImg":"FN","helperText":"GN","upsellHeadline":"HN","price":"IN","upsellGross":"JN","upsellNet":"KN","upsellButton":"LN","nutritionfacts":"MN","nutritionimg":"NN","containerwhy":"ON","nutritionwrappwer":"PN","headlinewhy":"QN","boxwhy":"RN","textwhy":"SN","backbutton":"TN","drawercontainer":"UN","logoheader":"VN","textwrap":"WN","timer":"XN"};
    if(module.hot) {
      // 1711394579781
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  